import { apiShifts } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'shifts';

const config = [
  { actionType: 'getAll', apiPath: apiShifts, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiShifts}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
